export default __webpack_public_path__ + "static/media/im6.0a7f7d67.jpg";